<template>
  <el-dialog
    :title="$t('purchasing.pay')"
    custom-class="MyDialog"
    :visible.sync="paymentFeesDialogVisible"
    :close-on-click-modal="false"
    @close="closePaymentFeesDialog"
    width="1000px"
  >
  <div>
    <div class="purchase-fees-info">
      <div class="textOne">
        <span>{{ $t('purchasing.purchaseOrderNo') }}：{{ payData.orderNo }}</span>
        <span>{{ $t('purchasing.orderTime') }}：{{ payData.orderCreateTime }}</span>
      </div>
      <div class="textTwo">
        <span>{{ $t('purchasing.purchaseQty') }}：{{ payData.buyNum }}{{ $t('purchasing.units') }}</span>
        <span>{{ $t('purchasing.purchaseAmount') }}：
          <span :style="{ color: 'red' }">{{payData.orderAmount}}</span>
        </span>
        <span>{{ $t('purchasing.actualPaymentAmount') }}：
          <span :style="{ color: 'red' }">{{payData.receivedAmount}}</span>
        </span>
      </div>
      <div class="programme-box">
        <p class="programme-title">{{ $t('purchasing.shippingPlan') }}：</p>
        <ul class="programme-ul">
          <li class="programme-1">
            {{ $t('purchasing.plan1') }}: {{ $t('purchasing.freightCollect') }}:
            <span class="programme-price">{{payData.freightOriginalAmount}}{{ $t('purchasing.yuan') }}</span>
            （{{ $t('purchasing.freightCollectTipLong') }}）
          </li>
          <li>
            {{ $t('purchasing.plan2') }}: {{ $t('purchasing.freightPrepay') }}:
            <span class="programme-price">{{payData.freightAmount}}{{ $t('purchasing.yuan') }}</span>
            （{{ $t('purchasing.originalPrice') }}{{payData.freightOriginalAmount}}{{ $t('purchasing.yuan') }}，{{ $t('purchasing.prepaidFreightTipLong') }}）
          </li>
        </ul>
      </div>
    </div>
    <div class="charge-table">
      <MyTable
        :titleData="titleData1"
        :tableData="tableData1"
        :index="true"
        :indexMethod="indexMethod"
      ></MyTable>
    </div>
    <div class="fees-tips-wrap">
      <p class="action-title">{{ $t('purchasing.purchaseFeeNoticeTitle') }}</p>
      <ul class="rules-ul">
        <li>{{ $t('purchasing.purchaseFeeRule1') }}</li>
        <li>{{ $t('purchasing.purchaseFeeRule2') }}</li>
        <li>{{ $t('purchasing.purchaseFeeRule3') }}</li>
      </ul>
    </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button  @click="closePaymentFeesDialog">{{ $t('app.cancel') }}</el-button>
      <el-button type="primary" @click="onlyOrderPay">{{ $t('equipment.payFreightCollect') }}</el-button>
      <el-button type="primary" @click="confirmButton">{{ $t('equipment.payFreightPrepay') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { queryOrderFreight, saveOrderFreight } from "@/api/AccountInterface";
import { resolveFormI18n, resolveTitleDataI18n } from "@/i18n/formI18n";
import MyTable from "@/components/table.vue";

export default {
  computed: {
    searchFormI18n() {
      return resolveFormI18n(this.searchForm, 'common', this.$t.bind(this));
    },
    titleDataI18n() {
      return resolveTitleDataI18n(this.titleData, 'common', this.$t.bind(this));
    },
  },

  data() {
    return {
      paymentFeesDialogVisible: false,
      titleData1: [
        {
          label: this.$t('app.auto_320_6d7330ec'),
          prop: "itemName",
          key: "itemName",
          align: "center"
          // fixed: 'left',
        },
        {
          label: this.$t('app.auto_321_fd898be3'),
          prop: "price",
          key: "price",
          align: "center"
          // fixed: 'left',
        },
        {
          label: this.$t('app.auto_322_bc3aabef'),
          prop: "buyNum",
          key: "buyNum",
          align: "center"
          // fixed: 'left',
        },
        {
          label: this.$t('app.auto_323_3ed4e1a5'),
          prop: "originalAmount",
          key: "originalAmount",
          align: "center"
          // fixed: 'left',
        },
        {
          label: this.$t('app.auto_324_01103e8f'),
          prop: "rateName",
          key: "rateName",
          align: "center"
          // fixed: 'left',
        },
        {
          label: this.$t('app.auto_325_b684f2f3'),
          prop: "amount",
          key: "amount",
          align: "center"
          // fixed: 'left',
        },
      ],
      tableData1: [],
      tableItems: [],
      payData: {},
    }
  },
  props: {
    showPaymentFeesDialog: {
      type: Boolean,
      default: false
    },
    orderNo: {
      type: String|Number,
      default: '',
    }
  },
  components: {
    MyTable,
  },
  watch: {
    showPaymentFeesDialog: {
      handler(newVal, oldVal) {
        console.log('newVal', newVal);
        this.paymentFeesDialogVisible = newVal;
      },
      immediate: true
    },
    // orderNo: {
    //   handler(newVal, oldVal) {
    //     this.paymentFeesDialogVisible = newVal;
    //   },
    //   immediate: true
    // },
  },
  mounted() {
    this.getOrderFreight();
  },
  methods: {
    getOrderFreight() {
      queryOrderFreight({orderNo: this.orderNo}).then(res => {
        if(res.code === 0) {
          this.payData = res.data;
          this.tableItems = res.data.items;
          let tableDataArr = JSON.parse(JSON.stringify(this.tableItems));
          tableDataArr.map(item => {
            if (item.itemName == this.$t('app.auto_326_53b37252')) {
              item['price'] = '';
              item['buyNum'] = '';
            }
          })
          this.tableData1 = tableDataArr;
        } else {
          this.payData = {};
          this.tableItems = [];
          this.$message.error(this.$getCodeMessage(res.code, res.message, res.messageArgs) || this.$t('app.auto_327_042286c8'));
        }
      })
    },
    saveOrderFreightHandler() {
      saveOrderFreight({
        orderNo: this.orderNo,
        items: this.tableData,
      }).then(ret => {
        if (ret.code === 0) {

        } else {
            this.$message.error(this.$getCodeMessage(ret.code, ret.message, ret.messageArgs) || this.$t('app.auto_328_dae8e444'));
          }
        })
    },
    closePaymentFeesDialog() {
      this.paymentFeesDialogVisible = false;
      this.$emit('closePaymentFeesDialog');
    },
    indexMethod(index) {
      return index + 1;
    },
    onlyOrderPay() {
      saveOrderFreight({
        orderNo: this.orderNo,
        items: [],
      }).then(ret => {
        if (ret.code === 0) {
          this.paymentFeesDialogVisible = false;
          this.$emit('yufeidaofuSuccess');
      } else {
          this.$message.error(this.$getCodeMessage(ret.code, ret.message, ret.messageArgs) || this.$t('app.auto_329_f7e1aacc'));
        }
      })
    },
    confirmButton() {
      saveOrderFreight({
        orderNo: this.orderNo,
        items: this.tableItems,
      }).then(ret => {
      if (ret.code === 0) {
        this.paymentFeesDialogVisible = false;
        this.$emit('yushouyunfeiSuccess');
      } else {
        this.$message.error(this.$getCodeMessage(ret.code, ret.message, ret.messageArgs) || this.$t('app.auto_330_bece925e'));
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.purchase-fees-info {
  color: #4A83E8;
  background: rgb(232, 243, 254);
  width: 100%;
  margin: 0 auto;
  border-radius: 10px;
  font-size: 14px;
  overflow: hidden;
  margin-bottom: 20px;

  .textOne {
    width: 90%;
    height: 20px;
    margin: 10px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .textTwo {
    width: 90%;
    height: 20px;
    margin: 10px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.programme-box {
  margin-top: 10px;
  margin-left: 50px;
  padding-bottom: 15px;
  color: #1890ff;
  .programme-title {
    font-weight: 500;
  }
  .programme-price {
    color: rgba(224, 58, 50, 1);
    font-weight: 500;
    font-family: PingFangSC-Medium, PingFang SC;
  }
  .programme-ul {
    margin-top: 10px;
    margin-bottom: 0;
    .programme-1 {
      margin-bottom: 10px;
    }
  }
}

.fees-tips-wrap {
  margin-top: 20px;
  margin-bottom: 10px;
  .action-title {
    color: #1890ff;
    font-size: 14px;
  }
  .rules-ul {
    margin-top: 20px;
    li {
      color: #1890ff;
      font-size: 14px;
    }
  }
}
</style>
